<template>
  <div class="active_jd_wrapper">
    <div class="detailes-wd">
      <section class="details-top">
        <div class="details-nav">
          <img class="details-nav-mobile" src="./images/banner.jpg" alt="新时代的中国第二届现实题材主题征文大赛获奖作品" >
          <img class="details-nav-pc" src="./images/banner_pc.jpg" alt="新时代的中国第二届现实题材主题征文大赛获奖作品" >
        </div>
        <div class="details-title wp">
          <div class="bj_say">
            <div class="bj_say_bg"></div>
          </div>
          <div class="bj_txt txt-p">
            <p>光辉历程：庆祝中国共产党成立100周年优秀网络文艺作品展示</p>
          </div>
        </div>
      </section>

      <section class="detailes-list wp">
        <div class="ul report" data-poscode="wkr99901"  data-itemcode="wkr9990101" v-for="(item, index) in list" :key="index" :data-scbookid="item.id" @click="toBook(item.id)">
          <div class="li">
            <van-image lazy-load :src="item.cover" />
          </div>
          <div class="li">
            <div class="dtl-link">
              <p class="detailes-list-title">{{item.name}}</p>
              <p class="dateiles-list-main">{{item.description}}</p>
              <div class="detailes-bottom">
                <div class="detailes-author">{{item.author}}</div>
                <div class="detailes-tags">{{formatCate(item.cate1_id)}}</div>
                <div class="detailes-txtnum">{{formatWord(item.word_count)}}字</div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import wkReader from "../../common/js/wkreader";
import utils from '../../common/js/utils';
import API from "../../api/API";
import Report from "../../common/js/report";
import ReportUnsafe from "../../common/js/report_unsafe";

import { book_list, cate_map } from "./books";

import Image from "vant/lib/image";
import "vant/lib/image/style";

const PAGE_CODE = 'wkr999'
export default {
  data () {
    return {
      isClient: false,
      ReportItemCode: null,
      ReportObject: null,
      list: book_list
    }
  },
  created () {
    this.isClient = wkReader.haveWkR() || wkReader._haveMethod('webkit.messageHandlers.getTokenkeyWithH5')
    this.init()
  },
  methods: {
    init() {
      wkReader.getTokenkeyWithH5((token_key) => {
        console.log('---------', token_key)
        if (token_key) {
          if (!this.ReportItemCode) {
            this.ReportItemCode = new Report({
              page_code: PAGE_CODE,
              token_key: token_key
            })
          }
        } else {
          if (!this.ReportObject) {
            this.ReportObject = new ReportUnsafe({
              page: 'active_jd',
            })
          }
        }
        
      })
    },
    toBook (id, poscode) {
      if (this.isClient) {  // 客户端
        let protocol = utils.getAppProtocol()
        let url = `${protocol}://app/go/bookdetail?bookid=${id}&from=active_jd_h5&extsourceid=${poscode}`
        console.log('url==>', url)
        window.location.href = url
      } else {    // 书籍 http://www.lsds.cn/
        let url = `http://www.lsds.cn/bookinfo/${id}.html?from=active_jd_h5&extsourceid=${poscode}`
        window.location.href = url
      }
    },
    formatWord (word) {
      if (word >= 10000) {
        return (word / 10000).toFixed(2) + '万'
      } else {
        return word
      }
    },
    formatCate (cate_id) {
      return cate_map[cate_id]
    }
  },
  components: {
    'van-image': Image
  }
}
</script>

<style>
.bj_txt p,
.dateiles-list-main {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.detailes-list .ul .li,
.details-title > div {
  float: left;
}
html {
  color: #000;
  background: #f5f4f9;
  font-family: "Microsoft YaHei" !important;
}
blockquote,
body,
dd,
div,
dl,
dt,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
input,
li,
ol,
p,
pre,
td,
textarea,
th,
ul {
  margin: 0;
  padding: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
a,
a:hover {
  text-decoration: none;
  color: #252525;
}
abbr,
acronym,
fieldset,
img {
  border: 0;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: 400;
}
ol,
ul {
  list-style: none;
}
caption,
th {
  text-align: left;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
q:after,
q:before {
  content: "";
}
.clear {
  clear: both;
}
.over-flow {
  overflow: auto;
  zoom: 1;
}
.bj_txt,
.detailes-bottom {
  overflow: hidden;
}
.flex {
  display: box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flex1 {
  -prefix-box-flex: 1;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
}
.wp{
  width: 100%;
}
.top-nav {
  padding: 0 0.3rem 0.2rem;
  max-width: 720px;
  margin: 0 auto;
  background: #fff;
}
.top-nav-four div {
  height: 1.3rem;
  width: 3.26rem;
  margin-top: 0.2rem;
  background: gray;
}
.top-nav-four div > img {
  width: 100%;
  height: 100%;
}
.main {
  margin-top: 0.2rem;
  background: #fff;
}
.main-title {
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.3rem;
  color: #333;
  text-align: center;
}
.main-title-s {
  position: relative;
}
.main-title-s::after,
.main-title-s::before {
  position: absolute;
  top: 0.13rem;
  width: 0.26rem;
  height: 0.17rem;
  content: "";
}
.main-title-s::after {
  right: -0.4rem;
  background: url(http://static.wkanx.com/w001/M00/42/B6/CgqN3FoOiGiAH8cLAAAD6jLOG7I654.png)
    100% 100% no-repeat;
  background-size: 0.26rem 0.17rem;
}
.main-title-s::before {
  left: -0.4rem;
  background: url(http://static.wkanx.com/w001/M00/42/B2/Cgp0RVoOiFmAYGkFAAAD4hPYJzM599.png)
    100% 100% no-repeat;
  background-size: 0.26rem 0.17rem;
}
.main-img > img {
  width: 100%;
  height: 2.66rem;
  margin: 0 auto;
}
.details-nav {
  width: 100%;
  font-size: 0;
}
.details-nav > img {
  width: 100%;
  height: 100%;
}
.details-title {
  width: 100%;
  height: 1.4rem;
  background: #fff;
}
.bj_say {
  width: 1.91rem;
  height: 100%;
  padding: 0.4rem 0.3rem;
  box-sizing: border-box;
}
.bj_say_bg{
  height: 100%;
  width: 100%;
  background: url(http://static.wkanx.com/w001/M00/42/B1/Cgp4R1oOiCKAE8xgAAAK30T-XsY570.png)
    no-repeat center center;
    background-size: contain;
}
.bj_txt {
  position: relative;
  font-size: 0.26rem;
  color: #8f97aa;
  /* line-height: 0.5rem; */
  height: 100%;
  width: 5.1rem;
  padding: 0.1rem 0.3rem 0 0.5rem;
  box-sizing: border-box;
}
.bj_txt::after,
.bj_txt::before {
  position: absolute;
  width: 0.26rem;
  height: 0.2rem;
  content: "";
}
.bj_txt p {
  display: -webkit-box;
}
.bj_txt::before {
  top: 0.3rem;
  left: 0;
  background: url(http://static.wkanx.com/w001/M00/42/B1/Cgp4R1oOiDqAG3NNAAAEZKsuO0k663.png)
    no-repeat;
  background-size: 0.26rem 0.2rem;
}
.bj_txt::after {
  top: 1.154rem;
  right: 0;
  background: url(http://static.wkanx.com/w001/M00/42/B2/Cgp0RVoOiE6AaAbrAAAEaUmr_VU013.png)
    no-repeat;
  background-size: 0.26rem 0.2rem;
}
.detailes-list {
  margin-top: 0.2rem;
  height: auto;
  background: #fff;
}
.detailes-list .ul:nth-child(1) {
  border: none;
}
.detailes-list .ul {
  width: 100%;
  box-sizing: border-box;
  padding: 0.2rem 0.3rem 0;
  height: 2.34rem;
  border-top: solid 1px #f5f5f9;
  display: flex;
}
.detailes-list .ul:active{
  background: rgba(0, 0, 0, 0.03);
}
.detailes-list .ul .li:nth-child(1) {
  width: 1.4rem;
  height: 1.94rem;
  flex: 0 0 1.4rem;

}
.detailes-list .ul .li:nth-child(2) {
  margin-left: 0.3rem;
  flex: 1 1 auto;
}
.detailes-list .ul .li img {
  width: 1.4rem;
  height: 1.94rem;
}
.detailes-list-title {
  font-size: 0.32rem;
  color: #333;
}
.dateiles-list-main {
  font-size: 0.28rem;
  color: #999;
  display: block;
  display: -webkit-box;
  line-height: 1.5;
  height: 0.8rem;
  overflow: hidden;
  margin-top: 0.1rem;
}
.detailes-author {
  position: relative;
  float: left;
  font-size: 0.24rem;
  color: #999;
  margin: 0.2rem 0.3rem;
}
.detailes-author::before {
  position: absolute;
  content: "";
  top: 0.05rem;
  left: -0.25rem;
  width: 0.2rem;
  height: 0.22rem;
  background: url(http://static.wkanx.com/w001/M00/42/B1/Cgp4R1oOh-WAey7YAAAFNq3x8kU635.png)
    no-repeat;
  background-size: 0.2rem 0.22rem;
}
.detailes-tags,
.detailes-txtnum {
  float: right;
  font-size: 0.2rem;
  color: #999;
  margin: 0.2rem 0.05rem;
  padding: 0 0.1rem;
  border-radius: 4px;
  height: 0.3rem;
  line-height: 0.3rem;
  position: relative;
}
.addC .bj_txt,
.addC .detailes-list-title {
  font-size: 0.16rem;
}
.detailes-tags::after,
.detailes-txtnum::after {
  content: "";
  position: absolute;
  width: 200%;
  height: 200%;
  border: 1px solid #ccc;
  -webkit-transform-origin: 0 0;
  -moz-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scale(0.5, 0.5);
  -ms-transform: scale(0.5, 0.5);
  -o-transform: scale(0.5, 0.5);
  transform: scale(0.5, 0.5);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  top: 0;
  left: 0;
  border-radius: 5px;
}
.detailes-wd {
  /* max-width: 750px; */
  margin: 0 auto;
}
.addC .details-nav {
  height: auto;
}
.addC .bj_say {
  margin: 0;
}
.addC .bj_txt {
  line-height: 0.3rem;
  width: 60%;
}
.addC .bj_txt::before {
  top: 0;
  left: -0.3rem;
}
.addC .bj_txt::after {
  top: 0.4rem;
  right: -0.2rem;
}
.addC .detailes-list {
  padding: 0 0.05rem;
}
.addC .dateiles-list-main {
  font-size: 0.1rem;
}
.addC .detailes-author {
  position: relative;
  float: left;
  font-size: 0.12rem;
  color: #999;
  margin: 0.1rem 0.2rem;
}
.addC .detailes-author::before {
  position: absolute;
  content: "";
  top: 0.03rem;
  left: -0.15rem;
  width: 20px;
  height: 22px;
  background: url(http://static.wkanx.com/w001/M00/42/B1/Cgp4R1oOh-WAey7YAAAFNq3x8kU635.png)
    no-repeat;
  background-size: 20px 22px;
}
.addC .detailes-tags,
.addC .detailes-txtnum {
  font-size: 0.12rem;
  margin: 0.1rem 0.05rem;
}
.addC .detailes-list .ul .li img,
.addC .detailes-list .ul .li:nth-child(1) {
  width: 1rem;
  height: 1.44rem;
}
.addC .detailes-list .ul .li:nth-child(2) {
  margin-left: 0.1rem;
  width: 65%;
}
.addC .dateiles-list-main {
  height: 0.75rem;
  -webkit-line-clamp: 5;
}
.addC .detailes-list .ul {
  height: 1.5rem;
}
.addC .details-title {
  height: 0.7rem;
}
.addCM .top-nav {
  padding: 0 0.1rem 0.2rem;
}
.addCM .top-nav-four div {
  height: 0.7rem;
  width: auto;
  margin-top: 0;
  background: 0 0;
  margin-bottom: 0.1rem;
}
.addCM .main-title {
  font-size: 0.16rem;
}
.addCM .main-title-s::after,
.addCM .main-title-s::before {
  top: 0;
}
.addCM .main-img img {
  height: auto;
}
.addAD .detailes-tags,
.addAD .detailes-txtnum {
  line-height: 0.35rem;
}
.txt-p {
  display: flex;
  justify-content: center;
  align-items: Center;
}
.details-nav-pc{
  display: none;
}

@media (min-width:769px) {
    body{
        background: #ffffff;
    }
    .details-nav-mobile{
      display: none;
    }
    .details-nav-pc{
      display: block;
    }
    .wp{
      width: 1000px;
      margin: 0 auto;
    }
    .details-title{
      height: 100px;
      display: flex;
    }
    .bj_say{
      display: none;
    }
    .bj_txt{
      font-size: 16px;
      padding: 0;
      width: 100%;
    }
    .bj_txt::before{
      background-size: 0.13rem 0.1rem;
      top: 20px;
      left: 20px;
    }
    .bj_txt::after{
      bottom: 20px;
      right: 20px;
      background-size: 0.13rem 0.1rem;
      top: auto;
    }
    .detailes-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 15px;
    }
    .detailes-list .ul{
      width: 50%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 20px 10px;
      border-bottom: 1px solid #e6e6e6;
      height: auto;
      border-top: none;
      cursor: pointer;
    }
    .detailes-list .ul:hover{
      background: rgba(0, 0, 0, 0.03);
    }
    .detailes-list .ul .li:nth-child(1){
      width: 20%;
      height: 136px;
      margin-right: 15px;
      flex: 0 0 20%;
      font-size: 0;
    }
    .detailes-list .ul .li:nth-child(2){
      margin-left: 0;
    }
    .detailes-list-title{
      font: 18px/24px PingFangSC-Regular,HelveticaNeue-Light,Helvetica Neue Light,Microsoft YaHei,sans-serif;
      overflow: hidden;
      margin-bottom: 8px;
    }
    .detailes-list .ul .li img{
      display: block;
    width: 100%;
    height: 100%;
    }
    .dateiles-list-main{
      font-size: 14px;
      line-height: 24px;
      overflow: hidden;
      height: 72px;
      margin: 8px 0;
    }
    .detailes-author, .detailes-tags, .detailes-txtnum{
      margin: 0;
      font-size: 12px;
    }
    .detailes-tags, .detailes-txtnum{
      height: auto;
      line-height: 1;
      padding: 5px;
    }
    .detailes-list .ul:nth-child(1){
      border-bottom: 1px solid #e6e6e6;
    }
    .dateiles-list-main {
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .detailes-txtnum{
      margin-right: 10px;
    }
    
}
</style>


// WEBPACK FOOTER //
// src/module/active_jd/App.vue